/* This file contains the progressBar component */
import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import LinearProgress from '@material-ui/core/LinearProgress';
import { getCustomColors } from '../styles/CustomColors';

const Colors = getCustomColors();

const BorderLinearProgress = withStyles(theme => ({
    root: {
        height: theme.spacing(1.5),
        borderRadius: theme.spacing(2),
    },
    colorPrimary: {
        backgroundColor: Colors.PROGRESS_CONTAINER_COLOUR,
        boxShadow: 'inset 0 1px 1px #C9DBE4'
    },
    bar: {
        backgroundColor: Colors.PROGRESS_BAR_COLOUR,
    },
}))(LinearProgress);

export default function ProgressBar({ widthPercentage, className }) {
    return <BorderLinearProgress variant="determinate" className={className} value={widthPercentage} />;
}
